import { createAction } from '@reduxjs/toolkit';

import { mbcDashboardModule } from './constants';

export const routeMBCDashboard = createAction(
  `${mbcDashboardModule}/ROUTE_MBC_DASHBOARD`,
);
export const ROUTE_MBC_DASHBOARD = routeMBCDashboard.type;
